var map = {
	"./": 2812,
	"./App": 4111,
	"./App.css": 4050,
	"./App.js": 4111,
	"./App.test": 6029,
	"./App.test.js": 6029,
	"./assets/Bear-Rugs.png": 1140,
	"./assets/Chairs.jpg": 6522,
	"./assets/Cola-Machine.jpg": 1755,
	"./assets/Dicemaster.jpg": 1299,
	"./assets/Dragon-Egg.jpg": 9337,
	"./assets/Green-Garland.jpg": 5009,
	"./assets/HC-Plasto.jpg": 5437,
	"./assets/HC-Sofa.jpg": 2095,
	"./assets/Habbo-Character.png": 7520,
	"./assets/Imperial-Teleport.jpg": 6595,
	"./assets/Majestic-Chair.jpg": 6852,
	"./assets/Mochamaster.jpg": 9002,
	"./assets/Nordic-Table.jpg": 5716,
	"./assets/Oil-Lamp.jpg": 1587,
	"./assets/PH-Box.jpg": 9176,
	"./assets/Petal-Patch.jpg": 9839,
	"./assets/Pillow.jpg": 1855,
	"./assets/Pods.jpg": 636,
	"./assets/Purple-Garland.jpg": 4496,
	"./assets/Study-Desk.jpg": 515,
	"./assets/Throne-Sofa.jpg": 9500,
	"./assets/Tubmaster.jpg": 5453,
	"./assets/google.png": 7597,
	"./components/Footer": 834,
	"./components/Footer.css": 2161,
	"./components/Footer.js": 834,
	"./components/Header": 8140,
	"./components/Header.css": 3915,
	"./components/Header.js": 8140,
	"./components/News": 7930,
	"./components/News.css": 6997,
	"./components/News.js": 7930,
	"./components/PriceComparisonModal": 12,
	"./components/PriceComparisonModal.css": 2759,
	"./components/PriceComparisonModal.js": 12,
	"./components/PriceItem": 4519,
	"./components/PriceItem.css": 9536,
	"./components/PriceItem.js": 4519,
	"./components/PriceList": 6588,
	"./components/PriceList.css": 7253,
	"./components/PriceList.js": 6588,
	"./components/firebase": 5040,
	"./components/firebase.js": 5040,
	"./components/rares.txt": 4464,
	"./data/habboPrices": 4004,
	"./data/habboPrices.json": 4004,
	"./index": 2812,
	"./index.css": 9555,
	"./index.js": 2812,
	"./logo.svg": 9445,
	"./reportWebVitals": 9031,
	"./reportWebVitals.js": 9031,
	"./setupTests": 9472,
	"./setupTests.js": 9472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;